import type { IconProps } from './types';
import './icons.css';

export default function Checked({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 11}
      height={height || 9}
      viewBox="0 0 11 9"
      className={`icon icon-checked ${className || ''}`}
    >
      <path stroke="#fff" fill="transparent" d="m1 4 3 3 6-6" />
    </svg>
  );
}
